import ODALogo from "../assets/logos/oda_logo.svg"
import ComunidadEnRetornoLogo from "../assets/logos/comunidad-en-retorno.png"
import CoalitionMigrantsChicago from "../assets/logos/coalition-migrant-mx.png"
import tarjetaVerdeEsp from '../assets/Tarjeta-Verde_conoce-tus-derechos-en-mexico.jpg'

export const es_MX = {
    "title": "Conoce tus Derechos en México",
    "subtitle": "Desde México a EUA, ¡no estás solx!",
    "blurb": "Existimos una comunidad organizada que ha estado navegando la vida tras la deportación y el retorno forzado.",
    "campaignName": "Tarjeta Verde",
    "description": "La Tarjeta Verde busca ser un medio que proporcione información esencial e importante a la población deportada y de retorno a México.",
    "description2": "A pesar del creciente miedo, dentro de las comunidades inmigrantes, hemos aprendido durante la última década, a través de nuestro trabajo de acompañamiento con personas deportadas y retornadas; que la información puede proporcionar una orientación esencial, ayudar a estar preparadxs y brindar un apapacho a quien se sienta solx en éste proceso.",
    printTitle: "Imprimir en casa",
    "print": [{
        "language": "Español",
        "fileName": 'Imprime Tarjetas Verdes desde casa',
        "link": "https://drive.google.com/file/d/1a3_HbHXKw8USYQ4prryr7y-x38hg_M5l/view?usp=sharing"
    }, {
        "language": "English",
        "fileName": 'Imprime Tarjetas Verdes desde casa',
        "link": "https://drive.google.com/file/d/1yshdD73euugTp_yuQ5UJWqXAb2QzDb-y/view?usp=sharing"
    }, {
        "language": "Tzotzil",
        "fileName": 'Imprime Tarjetas Verdes desde casa',
        "link": "https://drive.google.com/file/d/1bpMXHPCoK82UZmbvSAA0q9S6cyz0Duwg/view?usp=sharing",
    }],
    "about": {
        "title": "Sobre la campaña",
        subtitle: "Campaña",
        "objective": {
            "title": "Objetivo",
            "tool": "Con estas herramientas buscamos:",
            "points": {
                "1": "Tienes derechos en México, algunos que puedes acceder desde Estados Unidos y otros que deben ser respetados si te encuentras de regreso en México; aunque las instituciones traten de negarlos.",
                "2": "La información es clave. Ante el miedo, respondemos con información.",
                "3": "No estás solx, hay una comunidad que se ha estado organizando y navegando la vida después de la deportación y el retorno forzado.",
            },
            "to": "Para",
            "toPoints": {
                "1": "Evitar que nuestra comunidad de personas deportadas y retornadas sean discriminadas.",
                "2": "Reducir violaciones de derechos humanos.",
                "3": "Fortalecer relaciones con organizaciones pro-inmigrantes en ambos lados de la frontera México-E.U."
            }
        },
        "howToUse": {
            "title": "Uso de la tarjeta:",
            "usa": {
                subtitle: "En los Estados Unidos,",
                "description": " esta es una herramienta para organizaciones e individuos o Defensores de derechos humanos, con el fin de proporcionar recursos para quienes enfrentan una posible deportación o retorno forzado.",
                "description2": "Esta es una herramienta informativa y preventiva."
            },
            "mexico": {
                subtitle: "Una vez en México,",
                "description": " esta tarjeta será “activada”. Ya que proporciona información esencial para los primeros momentos de la llegada a México, un momento que sabemos puede estar lleno de miedo.",
                "description2": "Las personas deportadas y retornadas tendrán acceso a los números directos de ODA, así como de Comunidad en Retorno, y a una base de datos de otras organizaciones que puedan acompañarlos en el camino por venir."
            },
            image: tarjetaVerdeEsp,
        },
        "callToAction": {
            title: "Acompañanos",
            "subtitle": "¡Unamos esfuerzos en ambos lados de la frontera!",
            "whoCanJoin": "¿Eres una organización, red, abogado o líder comunitario? Únete al corredor translocal de acompañamiento.",
            "howToHelp": ["¡Corre la voz!",  "Comparte en redes sociales.",  "Imprime y comparte en Estados Unidos y México..", "Dona a la campaña!"]
        }
    },
    "donate": {
        "title": "Dona a la Campaña!",
        "link": "https://www.paypal.com/donate/?hosted_button_id=GY3U6M2DSQVZW"
    },
    "mediaKit": {
        "title": "¡Conoce más sobre la campaña!",
        "link": "https://drive.google.com/file/d/1Ja-8KGUSEls9KbNuN4Zce3uUsur95PYp/view"
    },
    callToAction: {
        title: "Súmate!",
        link: "https://forms.gle/3jJqN3vZMtBh4wNi8"
    },
    "directory": {
        "title": "Directorio de Apoyo",
        "description": "Tras la deportación y el retorno forzado, hemos aprendido que la experiencia es intergeneracional y diversa.",
        "description2": "¡Encuentra aquí más herramientas y guías diversas sobre cómo navegar la vida de regreso a México!"
    },
    "partners": {
        title: "Colaboradores",
        description: "En colaboración con Comunidad en Retorno, Otros Dreams en Acción y la Coalición de Migrantes Mexicanos, siguendo el ejemplo de la Tarjeta Roja creada por ILRC (Immigrant Legal Resource Center), estamos diseñando hermamientas para “Conocer Tus Derechos en México”.",
        list: [{
            "title": "Otros Dreams en Acción",
            "about": "ODA es una organización liderada por personas migrantes retornadas y deportadas, que buscan alianzas con otros sectores sociales para superar los retos y transformar las políticas que afectan a la migración de retorno y deportación en México desde una perspectiva de derechos.",
            logo: ODALogo,
            socials: {
                instagram: "https://www.instagram.com/otros_dreams_en_accion",
                facebook: "https://www.facebook.com/OtrosDreams",
                youtube: "https://www.youtube.com/@odaotrosdreamsenaccion6686",
                website: "http://www.odamexico.org"
            }
        }, {
            "title": "Comunidad en Retorno",
            "about": "Comunidad en Retorno es un grupo colectivo conformado por personas de la comunidad retornada o deportada y personas mexicanas relacionadas con el proceso de la migración en retorno.",
            logo: ComunidadEnRetornoLogo,
            socials: {
                instagram: "https://www.instagram.com/comunidadenretorno/",
                facebook: "https://www.facebook.com/p/Comunidad-en-retorno-100071424504267/",
                youtube: "https://www.youtube.com/@comunidadenretorno8174"
            }
        }, {
            "title": "Coalición de Migrantes Mexicanos",
            "about": "Nuestro objetivo es fortalecer los vínculos de los migrantes con su país de origen para mejorar e impactar su vida en lo local.",
            logo: CoalitionMigrantsChicago,
            socials: {
                facebook: "https://www.facebook.com/CoalicionDeMigrantesMexicanos",
            }
        }],
        thanks: "¡Gracias a todas las organizaciones que nos han acompañado en este proceso!",
        morePartnersTitle: "Más colaboradores"
    },
    faq: {
        title: "",
        subtitle: "Preguntas frecuentes",
        description: "",
        questions: [{
            question: "Qué es una Persona Deportada?",
            answers: [
                "Aquí tenemos dos tipos de deportados, aquellos que han vivido un proceso de deportación en sentido estricto y los que, por coerción,  tal vez no reconozcan que han vivido una deportación. Es importante recordar que, en su origen, la ley de inmigración es sólo administrativa; no implica intrínsecamente ningún conflicto con los sistemas penales, como la máquina de la deportación nos ha hecho creer. En esencia, una infracción administrativa, como saltarse un semáforo en rojo y la presencia indocumentada, estarían al mismo nivel.",
                "Cuando una persona es deportada en un sentido estricto, significa que han sido sujetas a un proceso administrativo, donde han estado en custodia de una autoridad administrativa migratoria y que han pasado un proceso para ser deportadas. En una imagen, estos son los miembros de nuestra comunidad que son retratados esposados por ICE mientras son entregados al gobierno mexicano.",
                "En cuanto a ser deportado en sentido amplio, esto incluye a cualquier persona que haya sido sometida a un proceso administrativo para ser expulsada o forzada a salir del país, aunque no haya sido escoltada fuera. Un ejemplo de ello es la salida voluntaria, que implica coaccionar a una persona para que firme un documento comprometiéndose a salir del país por sus propios medios."
            ]
        }, {
            question: "¿Qué es un Retornadx/Persona retornada forzada?",
            answers: ["Bajo la teoría de la inmigración, muchos se han referido a nuestra experiencia de regresar como voluntaria. Pero, ¿cómo podemos escoger libremente salir cuando vivimos en un país que activamente nos persigue e ilegaliza? La campaña activa de miedo propagada por ambos partidos, tanto republicano como el demócrata, emana de haber construido una máquina de deportación que es alimentada por la criminalización y deshumanización de nuestras comunidades migrantes. Esto lleva a un retorno forzado, o como hemos escuchado, a la “auto-deportación”. Lo que fuerza a las personas migrantes y a sus familias a dejar Estados Unidos por países como, pero no limitado a, México. ",
                "Sin embargo, nos apegamos a esta terminología de retornadx o persona forzada a retornar para amplificar la verdad, que hay otras violencias aparte de la máquina de deportación que fuerzan a nuestras comunidades a vivir en el exilio, como la falta de vivienda, educación, comida y de una vida digna en general. "
            ]
        }, {
            question: "¿Para qué me sirve la Constancia de Recepción de mexicanos Repatriados?",
            answers: ["Te Sugerimos guardar tu Hoja de repatriación",
                "Este documento sirve como identificación en caso de no llevar alguna identificación oficial.",
                "Te servirá para abordar el autobús y participar en los diversos Programas para repatriados en tu lugar de destino.",
                "La vigencia de la constancia dependerá del Programa al que desees participar.",
                {
                    text: "Con ella podrás cobrar tus envíos de dinero en las oficinas de TELECOMM según el directorio al final de esta ",
                    prompt: 'Guía',
                    url: "https://www.gob.mx/cms/uploads/attachment/file/45147/GUIA_SOMOS_MEXICANOS_PRIM.pdf"
                },
                'Nota:  Alguna información ya no está actualizada con la implementación del programa de  "Mexico te abraza"'
            ]
        }, {
            question: "¿Cómo obtengo mi INE?",
            answers: [
                {
                    text: "En México, consulta el proceso aquí: ",
                    prompt: " https://ine.mx/credencial",
                    url: "https://ine.mx/credencial"},
                {
                    text: "En el extranjero, consulta el trámite:",
                    prompt: " Aqui!",
                    url: "https://consulmex.sre.gob.mx/austin/index.php/documentacion/credencial-para-votar-en-el-extranjero"
                },
                "Es una identificación oficial que avala la ciudadanía mexicana y es la credencial para votar en México. Se ha convertido en uno de los documentos más importantes que en momentos cuando hay una veda electoral esta ha causado que personas retornadas se encuentren “indocumentados” en México, ya que esta credencial es solicitada para la mayoría de procesos como de empleo, renta y hasta entrar en algunos edificios.",
                "Si ya la tienes con residencia en el extranjero, una vez en México tendrás que solicitarla de nuevo ya que suele ser rechazada.",
                "Si no cuentas con un comprobante de domicilio para el trámite ante el INE y te encuentras en la CDMX podemos ayudarte con testigos.",
                {
                    text: "No puedes sacar tu INE por veda electoral, ",
                    prompt: " aprende que es una veda electora",
                    url: "https://youtu.be/FKh2HgknzXg?si=GiaYt-SU1aEebhaI"
                },
                "Si no puedes acceder a tu INE, contáctanos a retornodigno@odamexico.mx."
            ]
        }, {
            question: "¿Cómo conseguir mi acta de nacimiento?",
            answers: [
                {
                    text: "Se trata de un proceso que puede realizarse desde el extranjero.",
                    prompt: " Solicítalo aquí",
                    url: "https://www.gob.mx/ActaNacimiento/"
                },
                "Para hacer el trámite necesitarás tener a la mano la Clave Única de Registro de Población (CURP), tu nombre completo, fecha de nacimiento, entidad de registro, sexo y datos de filiación (nombre completo de la madre, padre o persona que te registró).",
                "La mayoría de las Actas de Nacimientos han sido subidas a una plataforma digital donde cualquier persona puede buscarlas e imprimirlas, sin embargo, en ocasiones una Acta de Nacimiento puede no estar en el sistema.",
                "Si se encuentra en los Estados Unidos, le recomendamos visitar el Consulado Mexicano más cercano.",
                {
                    text: "Hay un costo, ",
                    prompt: " consulta el costo por estado",
                    url: "https://www.gob.mx/tramites/ficha/expedicion-de-la-copia-certificada-del-acta-de-nacimiento-en-linea/RENAPO187"
                },
                "Si se encuentra en México o no puede acceder al soporte, contáctenos en retornodigno@odamexico.mx."
            ]
        }, {
            question: "¿Qué es una CURP y cómo encuentro la mía?",
            answers: [
                {
                    text: "Es un trámite que puedes hacer desde el extranjero. ",
                    prompt: " Tramítalo aquí",
                    url: "https://www.gob.mx/curp/"
                },
                "Es una clave alfanumérica de 18 caracteres que se utiliza para identificar a las personas residentes en México, independientemente de su nacionalidad. Es un instrumento fundamental para registrar de manera individual a todos los habitantes del país y a los mexicanos residentes en el extranjero.",
                "En otras palabras: Aunque en México existe otro sistema llamado seguridad social, la CURP es como un «social security number/número de seguridad social» de Estados Unidos.",
                {
                    prompt: " Más información",
                    url: "https://www.gob.mx/segob/acciones-y-programas/clave-unica-de-registro-de-poblacion-curp"
                },
                "Para solicitar asistencia telefónica sobre el servicio de CURP, puedes comunicarte al Centro de Atención y Servicio, de lunes a viernes, de 8:00 a 16:00 horas, a los teléfonos: 800 9 11 11 11, extensiones 15100 y 1510.",
                "Si no puedes acceder a tu CURP en México, contáctanos a retornodigno@odamexico.mx."
            ]
        }]
    }
}

export default es_MX;